import { Module } from "wrapper6";
import $ from 'jquery';

//curlang = current language
//cc = country code of your location
export default class CountryCodeChecker extends Module {
    ready() {
        const POPUP = $('.country-popup');
        const CLOSE = $('.closecc');
        const SETLANG = $('.setlang');

        const LANGCOOKIE = getCookie('lang');

        $(CLOSE).click(function () {
            $(POPUP).css('display', 'none');
            setCookie('lang', 'stop', 30);
        });

        let cc = countrycode ? countrycode : 'dk';

        //remove false to enable lang popup
        if(!LANGCOOKIE && false) {

            if (cc === 'dk' && curlang.toLowerCase() !== 'da') {
                let text = ''
                startCCPopup('da', POPUP, SETLANG)
            } else if (cc === 'gb' && curlang.toLowerCase() !== 'en') {
                startCCPopup('', POPUP, SETLANG)
            } else if (cc === 'cn' && curlang.toLowerCase() !== 'zh-hant') {
                startCCPopup('zh-hant', POPUP, SETLANG)
            } else if (cc === 'fr' && curlang.toLowerCase() !== 'fr') {
                startCCPopup('fr', POPUP, SETLANG)
            } else if (cc === 'de' && curlang.toLowerCase() !== 'de') {
                startCCPopup('de', POPUP, SETLANG)
            } else if (cc === 'us' && curlang.toLowerCase() !== 'us') {
                startCCPopup('us', POPUP, SETLANG)
            }


            if (cc.toLowerCase() !== curlang.toLowerCase()) {
                console.log('Not right lang');
                console.log(cc.toLowerCase());
                console.log(curlang.toLowerCase());
            }

        }
    }
}

function startCCPopup(lang, POPUP, SETLANG){
    $(POPUP).addClass('show')
    $(SETLANG).attr('href', $(SETLANG).data('link')+'/'+lang)
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}